import React from 'react';
import { View, Text, StyleSheet, Image, ScrollView } from 'react-native';
import { observer } from 'mobx-react';
import { RouteProp, useRoute } from '@react-navigation/native';
import { User } from '@interfaces/iuser';

interface UserDetailRouteParams {
  user: User;
}

type UserDetailRouteProp = RouteProp<{ UserDetail: UserDetailRouteParams }, 'UserDetail'>;

const UserDetail = observer(() => {
  const route = useRoute<UserDetailRouteProp>();
  const { user } = route.params;

  return (
    <ScrollView style={styles.container}>
      <Text style={styles.title}>Detalhes do Usuário</Text>

      {user.foto && (
        <Image source={{ uri: user.foto }} style={styles.avatar} />
      )}

      <View style={styles.infoBox}>
        <Text style={styles.label}>Nome:</Text>
        <Text style={styles.value}>{user.nome || '-'}</Text>
      </View>

      <View style={styles.infoBox}>
        <Text style={styles.label}>E-mail:</Text>
        <Text style={styles.value}>{user.email || '-'}</Text>
      </View>

      <View style={styles.infoBox}>
        <Text style={styles.label}>ID do Bebê Atual:</Text>
        <Text style={styles.value}>{user.currentBabyID || '-'}</Text>
      </View>

      <View style={styles.infoBox}>
        <Text style={styles.label}>Ativo:</Text>
        <Text style={styles.value}>{user.active ? 'Sim' : 'Não'}</Text>
      </View>

      <View style={styles.infoBox}>
        <Text style={styles.label}>Recebe Push:</Text>
        <Text style={styles.value}>{user.sendPush ? 'Sim' : 'Não'}</Text>
      </View>
    </ScrollView>
  );
});

export default UserDetail;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    backgroundColor: '#F2F2F2',
  },
  title: {
    fontSize: 22,
    fontWeight: 'bold',
    marginBottom: 20,
    color: '#333',
  },
  avatar: {
    width: 60,
    height: 60,
    borderRadius: 30,
    marginBottom: 10,
  },
  infoBox: {
    marginBottom: 15,
  },
  label: {
    fontSize: 14,
    color: '#666',
  },
  value: {
    fontSize: 16,
    fontWeight: '500',
    color: '#333',
  },
});
